import React from 'react';
import { Table, Button } from 'antd';
import numeral from 'numeral';
import {setUpColumnObject, setupOverviewData} from '../../utils/utils';

export class EconomicOverviewTable extends React.Component {
  state = {
    sortedInfo: null,
  };

  handleChange = (pagination, filters, sorter) => {
    //console.log('Various parameters', pagination, filters, sorter);
    this.setState({
      sortedInfo: sorter,
    });
  }

  clearAll = () => {
    this.setState({
      sortedInfo: null,
    });
  }

  render() {
    let { sortedInfo } = this.state;
    sortedInfo = sortedInfo || {};

    const columns = [
      setUpColumnObject('Industry', 'category', sortedInfo, true, 460),
      setUpColumnObject('Output ($m)', 'output', sortedInfo, false, 140),
      setUpColumnObject('Wages & Salaries ($m)', 'wages_salaries', sortedInfo, false, 200),
      setUpColumnObject('Value-Add ($m)', 'value_add', sortedInfo, false, 160),
      setUpColumnObject('Regional Import ($m)', 'regional_imports', sortedInfo, false, 200),
      setUpColumnObject('Regional Export ($m)', 'regional_exports', sortedInfo, false, 200)
    ];

    const dataSource = setupOverviewData(this.props.data);
    //console.log('dataSource', dataSource)

    return (
      <div className="table">
      <Table scroll={{ y: 600 }} 
      bordered={true} pagination={false} 
      columns={columns} dataSource={dataSource} onChange={this.handleChange} />
      </div>
    );
  }
}

export default EconomicOverviewTable;


// WEBPACK FOOTER //
// ./src/components/economicProfile/EconomicOverviewTable.js